var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1VideoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 34.33V27h-6.52a9 9 0 00-4.88-16.58 9 9 0 00-8.6 6.2 9.06 9.06 0 00-17.66 2.8A8.94 8.94 0 0021.52 27H14v24h16.51L23.9 68h4.38l6.61-17h2.38L44 68h4.39l-6.73-17H55v-8.1L65 48V29.23l-10 5.1zM43.6 16.42a3 3 0 110 6 3 3 0 010-6zm-8.6 5.8A8.93 8.93 0 0038.73 27h-7.46A8.93 8.93 0 0035 22.22zm-8.6-5.8a3 3 0 110 6 3 3 0 010-6zM51 47H18V31h33v16z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Video_image.b654c6b7.svg";
export { SvgH1VideoImage as ReactComponent };